import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";
import "./CompanyChartMF.css";
import { Rings } from 'react-loader-spinner';


function CompanyChart(props, ref) {

  let getMFCode = props.MFcode;
  const [data, setData] = useState([]);
  const [chartdata, setchartData] = useState([]);
  const [chartperiod, setchartperiod] = useState('1M');
  const { BaseURL } = useContext(URLstateContext);

  let getData, getchartData, indicator;

  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panY: false,

      layout: root.verticalLayout
    }));

    indicator = root.container.children.push(am5.Container.new(root, {
      width: am5.p100,
      height: am5.p100,
      layer: 1000,
      background: am5.Rectangle.new(root, {
        fill: am5.color(0xffffff),
        fillOpacity: 0.7
      })
    }));

    indicator.children.push(am5.Label.new(root, {
      text: "Loading...",
      fontSize: 25,
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50
    }));


    chart.get("colors").set("colors", [
      am5.color(0x024FA1),

    ]);

    // Create Y-axis
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 1,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    // Create X-Axis
    let baseI = chartperiod === "1M" ? { timeUnit: "minute", count: 1 } : { timeUnit: "month", count: 1 };


    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -60,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15
    });
    let xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
      //groupData: true,
      maxDeviation: 0.5,
      renderer: xRenderer,
      baseInterval: baseI,

    }));

    function generateChartData() {

      let chartData = [];

      if (chartdata != null && chartdata != []) {
        for (var i = 0; i < chartdata.length; i++) {
          let newDate = new Date(chartdata[i].NavDate);

          chartData.push({
            time: newDate.getTime(),
            price: chartdata[i].NAVRS
          });
        }
      }
      else {
        // <h3>No Data Found</h3>
      }
      return chartData;


    }

    // console.log("ddddd:"+JSON.stringify(generateChartData()));
    let data = generateChartData();



    //let lbltxt = "[bold]{name}[/]\n{valueX.formatDate()}: {valueY}";

    let lbltxt = chartperiod === "1M" ? "[bold] ₹ {valueY} | {valueX.formatDate('HH:mm')}" : "[bold] ₹ {valueY} | {valueX.formatDate('dd-MMM-yyyy')}";

    // Create series
    let series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "Series",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "price",
      valueXField: "time",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: lbltxt
      })
    }));

    series.strokes.template.set("strokeWidth", 2);
    series.fills.template.setAll({
      visible: true,
      fillOpacity: 0.4
    });
    if (chartperiod === "1M" || chartperiod === "3M") {
      series.bullets.push(function (root) {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: series.get("fill"),
            fill: am5.color(0x024FA1),
          })
        });
      });
    }

    series.set("fill", am5.color(0x80D962)); // set Series color to red



    series.data.setAll(data);



    series.fills.template.set("fillGradient", am5.LinearGradient.new(root, {
      stops: [{
        opacity: 0
      }, {
        opacity: 1
      }],
      rotation: 90
    }));

    // Add cursor
    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: xAxis
    }));

    xAxis.set("tooltip", am5.Tooltip.new(root, {}));

    yAxis.set("tooltip", am5.Tooltip.new(root, {}));
    indicator.hide();

    return () => {
      root.dispose();
    };
  }, [chartdata]);


  useEffect(() => {
    if(getMFCode != '') {
    const getUrl = BaseURL + "GetQuoteDetailsMF";
    fetch(`${getUrl}/${getMFCode}`)
      .then((response) => response.json())
      .then((data) => {
        getData = data.data;
        setData(getData);
         //console.log("aaaaaaa", getData);
      })
      .catch((error) => {
        //console.log("not found the api");
      });

    }
  }, [getMFCode]);

  useEffect(() => {
    const getUrlchart = BaseURL + "Company-Chart-MF";
    fetch(`${getUrlchart}/${getMFCode}/${chartperiod}`)
      .then((response) => response.json())
      .then((data) => {
        getchartData = data.data;
        setchartData(getchartData);
        // console.log("chartdata:",getchartData);
        // console.log("chartdata:"+JSON.stringify(getchartData));
      })
      .catch((error) => {
        // console.log("not found the api");
      });
  }, [getMFCode]);

  const clickchartperiodHandler = (priod) => {
    setchartperiod(priod);
    const getUrlchart = BaseURL + "Company-Chart-MF";
    // console.log(`${getUrlchart}/${getMFCode}/${priod}`)
    fetch(`${getUrlchart}/${getMFCode}/${priod}`)
      .then((response) => response.json())
      .then((data) => {
        getchartData = data.data;
        //console.log("chartdata", getchartData);
        setchartData(getchartData);
      })
      .catch((error) => {
        //console.log("not found the api");

      //  console.log("not found the api");

      });

  }


  return (
    <>
      <section className="company-chart-section">
     
        <Container className="table-box">
          <Row>
            <Col md={12}>

              <div>
                <ul className="day-data scheme">

                  <li className={chartperiod === "1M" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('1M')}>1 Month</li>
                  <li className={chartperiod === "3M" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('3M')}>3 Month</li>
                  <li className={chartperiod === "6M" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('6M')}>6 Month</li>
                  <li className={chartperiod === "1Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('1Y')}>1 Year</li>
                  <li className={chartperiod === "3Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('3Y')}>3 Year</li>
                  <li className={chartperiod === "5Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('5Y')}>5 Year</li>
                  <li className={chartperiod === "10Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('10Y')}>10 Year</li>
                </ul>
              </div>
              {(chartdata === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              <div id="chartdiv" style={{ width: "100%", height: "325px" }}></div>

            </Col>
          </Row>
        </Container>
       
      </section>
    </>
  );
}

export default React.forwardRef(CompanyChart);
